import { render, staticRenderFns } from "./Heartstone.vue?vue&type=template&id=7040ec18&scoped=true"
import script from "./Heartstone.vue?vue&type=script&lang=js"
export * from "./Heartstone.vue?vue&type=script&lang=js"
import style0 from "./Heartstone.vue?vue&type=style&index=0&id=7040ec18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7040ec18",
  null
  
)

export default component.exports